document.addEventListener('DOMContentLoaded', () => {
  const THRESHOLD = 20;
  const MESSAGE = "Veuillez noter que le délai de livraison sera entre 7 à 10 jours ouvrables pour cette quantité.";

  // 1 popup par variant
  const alertedVariantIds = new Set();

  // Evite les popups multiples pendant que le thème rafraîchit le tiroir
  let modalOpen = false;
  let checkTimer = null;

  function openModal() {
    if (modalOpen) return;
    if (document.getElementById('quantity-delivery-modal')) return;

    modalOpen = true;

    const wrap = document.createElement('div');
    wrap.id = 'quantity-delivery-modal';
    wrap.innerHTML = `
      <div class="qa-overlay" role="dialog" aria-modal="true" aria-label="Information livraison">
        <div class="qa-modal">
          <h3>⏱️ Information importante</h3>
          <p>${MESSAGE}</p>
          <div class="qa-actions">
            <button type="button" class="qa-close">J'ai compris</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    const overlay = wrap.querySelector('.qa-overlay');
    const closeBtn = wrap.querySelector('.qa-close');

    function close() {
      const el = document.getElementById('quantity-delivery-modal');
      if (el) el.remove();
      modalOpen = false;
    }

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    }, { once: true });
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return await res.json();
  }

  async function checkCartAndAlert() {
    try {
      const cart = await getCart();
      const items = cart.items || [];

      // Trouver les variants qui dépassent 20 et pas encore alertés
      const triggered = items
        .filter(i => i.quantity >= THRESHOLD && !alertedVariantIds.has(i.variant_id))
        .map(i => i.variant_id);

      if (triggered.length > 0) {
        triggered.forEach(id => alertedVariantIds.add(id));
        openModal();
      }
    } catch (e) {
      // on ignore si erreur
    }
  }

  // On "programme" un check (debounce) après les actions panier
  function scheduleCheck() {
    if (checkTimer) clearTimeout(checkTimer);
    checkTimer = setTimeout(() => {
      checkCartAndAlert();
    }, 600); // délai pour laisser le thème finir son update/tiroir
  }

  // A) Après n'importe quel add-to-cart via fetch (/cart/add)
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (url.includes('/cart/add')) {
          scheduleCheck();
        }
        // aussi utile si ton thème fait /cart/change quand tu cliques + dans le drawer
        if (url.includes('/cart/change') || url.includes('/cart/update')) {
          scheduleCheck();
        }
      } catch (e) {}

      return res;
    };
  }

  // B) Si le thème utilise des formulaires classiques parfois, on check après submit (sans bloquer)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const isCartForm =
      (form.action && (form.action.includes('/cart/add') || form.action.includes('/cart/change') || form.action.includes('/cart/update'))) ||
      form.querySelector('[name="add"]');

    if (isCartForm) {
      scheduleCheck();
    }
  }, true);
});
 // C) Page panier : détecter les + / - ou changement de quantité même sans fetch
  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart');
  }

  if (isCartPage()) {
    // 1) Au chargement du panier (si déjà 20+)
    scheduleCheck();

    // 2) Si la quantité change via input
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (el && el.matches && el.matches('input[name="updates[]"], input[name="quantity"], input.quantity__input')) {
        scheduleCheck();
      }
    });

    // 3) Si la quantité change via boutons + / -
    document.addEventListener('click', (e) => {
      const btn = e.target.closest?.('button, a');
      if (!btn) return;

      // Beaucoup de thèmes utilisent ces classes/attributs pour les boutons quantité
      if (
        btn.matches('.quantity__button, .quantity__button--plus, .quantity__button--minus') ||
        btn.getAttribute('name') === 'plus' ||
        btn.getAttribute('name') === 'minus' ||
        btn.getAttribute('aria-label')?.toLowerCase().includes('increase') ||
        btn.getAttribute('aria-label')?.toLowerCase().includes('decrease')
      ) {
        scheduleCheck();
      }
    });
  }